import queryString from 'query-string';


export function parseQuery(query) {
    return queryString.parse(query);
}
